module.exports = __webpack_public_path__ + "img/ppt-addin-02.8b991956.png";